import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'
import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults } from './types'

/**
 * Ô lọc trên header / toolbar — cao + viền khớp thanh tìm (`kiotSearchBar*`).
 */
const baseFilterToolbarStyle = buildFieldSurfaceStyleFromKiot()

export const FILTER_TOOLBAR_FIELD_SURFACE_STYLE = {
  ...baseFilterToolbarStyle,
  inputHeightPx: banhangKiotLike.kiotSearchBarHeightPx,
  borderColor: banhangKiotLike.kiotSearchBarBorder,
  borderHover: banhangKiotLike.kiotSearchBarBorderHover,
  borderRadiusPx: 6,
  focusShadow: '0 1px 3px rgba(0,0,0,0.08)',
  inputPaddingX: 8,
}

export const FILTER_TOOLBAR_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'above',
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
}
